const config = {
	API_URL: `${process.env.REACT_APP_PORTAL_URL}`,
	LOGIN_URL: `${process.env.REACT_APP_PORTAL_URL}/index.php/login`,
	PORTAL_CLIENT_URL: process.env.REACT_APP_PORTAL_CLIENT_URL,
};

export default config;
